import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import {PaymentMethodChoices} from '../../../pages/shopping-basket/cash-payment/utils/helpers';
import postCheckStoreOderOtp from './postCheckStoreOderOtp';

export interface IPostCheckStoreOrderOtpPayload {
  code: string;
  store_order: string;
  paymentType?: PaymentMethodChoices;
}

const usePostCheckStoreOderOtp = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCheckStoreOrderOtpPayload) =>
      postCheckStoreOderOtp(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCheckStoreOderOtp;
